/**
 * View modes for displaying archive content
 */
export type ViewMode = "month-view" | "search-results"

/**
 * Constants for view modes to avoid magic strings
 */
export const VIEW_MODES = {
  MONTH_VIEW: "month-view" as const,
  SEARCH_RESULTS: "search-results" as const,
} as const
